<template>
<!--  <div style="width: 200px">-->
<!--    <v-text-field-->
<!--      name="name"-->
<!--      single-line-->
<!--      dense-->
<!--      v-model="searchParam"-->
<!--      hide-details-->
<!--      placeholder="请输入关键字/书名/作者"-->
<!--      clearable-->
<!--      :append-icon="icons.mdiMagnify"-->
<!--      @click:append="searchBook"-->
<!--    >-->
<!--    </v-text-field>-->
<!--  </div>-->
</template>

<script>
  import { mdiMagnify } from '@mdi/js'
  export default {
    data() {
      return {
        eid: '',
        icons:{mdiMagnify},
        searchParam:''
      }
    },
    methods: {
      searchBook(){
        this.$store.dispatch('category/commitSearchBook', this.searchParam)
        this.$store.dispatch('category/commitSearchFlag', true)
        if(this.$route.path !== '/category'){
          let routerData = this.$router.resolve({ path:'/category/' + this.searchParam  })
          window.open(routerData.href,'_blank')
        }
      }
    },
  }
</script>

<style lang="scss"></style>
